import React from 'react';
import { UiFlex, UiIconMaterial } from '@open-stack/ui';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { OrderHistoryPage } from '../../../pages/order/history/OrderHistoryPage';
import { useZoneLastVisited } from '../../../hooks/zone-last-visited';
import { useRouter } from '../../../hooks/router';
import { RootIdPage } from '../../../pages/id/RootIdPage';
import { BrowsePage } from '../../../pages/browse/BrowsePage';
import { AccountPage } from '../../../pages/account/AccountPage';
import { CovidNavTab } from '../../covid/nav-tab/CovidNavTab';
import { XText, XTextType } from '../../x/text/XText';
import { useLayoutFooter } from '../../../hooks/useLayoutFooter';
import clsx from 'clsx';

const Wrapper = styled.div`
    &.hasPlaceholder {
        height: calc(var(--bottom-nav-height) + 2 * var(--ui-spacing));
    }

    .footer {
        position: fixed;
        z-index: var(--z-index-toolbar);
        background: var(--bottom-nav-background);
        box-shadow: var(--bottom-nav-box-shadow);
        height: var(--bottom-nav-height);
        border-radius: var(--bottom-nav-border-radius);
        bottom: calc(2 * var(--ui-spacing));
        width: calc(100% - 2 * 12px);
        max-width: var(--drawer-max-width);
        padding: 4px;
        left: 50%;
        transform: translateX(-50%);
    }

    .UiButton {
        border-radius: 0;
    }

    .tab {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: var(--ui-size-2);
        transition: color 200ms;
        position: relative;
        color: var(--bottom-nav-tab-color-inactive);

        > :nth-child(2) {
            display: block;
            margin-top: 4px;
        }

        &.active {
            color: var(--bottom-nav-tab-color-active);
        }

        &.zone {
            font-size: var(--UiText-font-size--1);
            font-weight: bold;
            text-align: center;
            line-height: 1;

            .outlet-name {
                font-size: 0.7rem;
            }

            > :nth-child(2) {
                margin-top: 0;
            }
        }

        .badge {
            position: absolute;
            top: -2px;
            right: calc(50% - 40px);
            font-size: var(--UiText-font-size-0);
            font-weight: bold;
            color: var(--ui-color-white);
            background-color: var(--x-color-secondary);
            border-radius: 100%;
            height: 24px;
            width: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    //.tab {
    //    & > :nth-child(2) {
    //        opacity: 0;
    //        max-height: 0;
    //        transition: 300ms;
    //        overflow: hidden;
    //    }
    //
    //    &.active > :nth-child(2) {
    //        margin-top: 4px;
    //        max-height: 14px;
    //        opacity: 1;
    //    }
    //}
`;

export function LayoutBottomNavigation() {
    const hasPlaceholder = useLayoutFooter().hasPlaceholder();
    const { replaceParams } = useRouter();
    const { zoneLastVisited } = useZoneLastVisited();

    return (
        <Wrapper className={clsx('LayoutBottomNavigation', { hasPlaceholder })}>
            <UiFlex className="footer" flexChildren>
                {zoneLastVisited && (
                    <NavLink to={replaceParams(RootIdPage, { id: zoneLastVisited.zoneHash })} className="tab zone">
                        <XText className="outlet-name">{zoneLastVisited.outletName}</XText>
                        <div>{zoneLastVisited.zoneName}</div>
                    </NavLink>
                )}

                <CovidNavTab />

                <NavLink to={BrowsePage.route} className="tab">
                    <UiIconMaterial>place</UiIconMaterial>
                    <XText type={XTextType.LABEL}>Venues</XText>
                </NavLink>

                <NavLink to={OrderHistoryPage.route} className="tab">
                    {/*{orders.length > 0 && <span className="badge animate__animated">{orders.length}</span>}*/}
                    <UiIconMaterial>receipt_long</UiIconMaterial>
                    <XText type={XTextType.LABEL}>Receipts</XText>
                </NavLink>

                <NavLink to={AccountPage.route} className="tab">
                    <UiIconMaterial>person</UiIconMaterial>
                    <XText type={XTextType.LABEL}>Profile</XText>
                </NavLink>
            </UiFlex>
        </Wrapper>
    );
}
